import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { StatusIndicatorDot as n, cn as r } from "@vintecc/components";
//#region src/components/ErrorIndicatorDot/index.tsx
var i = ({ children: i, show: a, className: o }) => /* @__PURE__ */ t("div", {
	className: "relative inline-flex justify-center items-center",
	children: [i, /* @__PURE__ */ e(n, {
		show: a,
		intent: "error",
		className: r("absolute top-0 -right-0 transform translate-x-1/2 -translate-y-1/2", o)
	})]
});
//#endregion
export { i as t };

//# sourceMappingURL=ErrorIndicatorDot-BJKDPGHu.js.map